// extracted by mini-css-extract-plugin
export default {"anchor":"Link_anchor__ylL8n","label":"Link_label__WCtGv"};